import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import "react-datepicker/dist/react-datepicker.css";
import {callLogout, login} from "../services/api";
import {useDispatch, useSelector} from "react-redux";
import Cookies from "universal-cookie";
import {setLogged, setUserData, setUserType,} from "../store/reducers/listingReducer";
import {FormikInput} from "./ui/FormikInput";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";

interface IProps {
    isOpen: boolean;
    close: () => void;
}

export const Login = () => {
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const navigate = useNavigate()
    const [show, setShow] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const logged = useSelector((state: any) => state.listingReducer.logged);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    async function doLogin(email: string, password: string) {
        setErrorMessage("");
        let params: any = {};
        params["password"] = password;
        params["email"] = email;
        let data = await login(params);
        if (data.data.success === true) {
            cookies.set("listings-app-login", true);
            localStorage.setItem("listings-app-login", "true");
            localStorage.setItem("listings-app-user-type", data.data.data.user_type);
            localStorage.setItem("listings-app-api-token", data.data.data.api_token);
            setShow(false);
            dispatch(setLogged(true));
            dispatch(setUserType(data.data.data.user_type));
            dispatch(setUserData(data.data.data));
            navigate('/')
        } else {
            setErrorMessage("Invalid Credentials");
            dispatch(setLogged(false));
            dispatch(setUserData(null));
        }
    }

    const logout = async () => {
        await callLogout();
        dispatch(setLogged(false));
        dispatch(setUserData(null));
        //window.location.reload();
        return true;
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email("Enter valid email")
            .required("Email is required"),
        password: Yup.string().required("Password is required"),
    });

    return (
        <Dialog.Root open={true}>
            <Dialog.Portal>
                <Dialog.Overlay className="bg-gray-800 bg-opacity-60 fixed inset-0 z-40"/>
                <Dialog.Content
                    style={{transform: "translate(-50%, -50%)"}}
                    className="fixed left-1/2 top-1/2 bg-white p-6 z-40 min-w-[30rem]"
                >
                    <Formik
                        initialValues={{email: "", password: ""}}
                        onSubmit={async (val: any) => {
                            console.log({val});
                            await doLogin(val.email, val.password);
                        }}
                        validationSchema={validationSchema}
                    >
                        <Form>
                            <div className="flex flex-col gap-y-3">
                                <FormikInput
                                    containerClassName="flex flex-col gap-y-2"
                                    label="Email"
                                    name="email"
                                />

                                <FormikInput
                                    containerClassName="flex flex-col gap-y-2"
                                    label="Password"
                                    name="password"
                                    type="password"
                                />
                            </div>

                            {errorMessage ? (
                                <div className="p-3 bg-red-400 text-white mt-4">
                                    {errorMessage}
                                </div>
                            ) : null}

                            <div className="mt-4 flex w-full justify-end gap-x-4">
                                <Link
                                    to="/register"
                                    className="px-4 py-2 border"
                                    type="button"
                                >
                                    Register
                                </Link>
                                <button
                                    className="px-4 py-2 bg-primary text-white"
                                    type="submit"
                                >
                                    Login
                                </button>
                            </div>
                        </Form>
                    </Formik>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );

    // return (
    //     <>
    //         {logged &&
    //             <a href="#" onClick={logout} className={"header-links"}><FontAwesomeIcon
    //                 icon={faSignIn}/><span> Logout</span></a>
    //         }
    //         {!logged &&
    //             <a href="#" onClick={handleShow} className={"header-links"}><FontAwesomeIcon
    //                 icon={faSignIn}/><span> Sign In</span></a>
    //         }
    //         <Modal show={show} onHide={handleClose} centered>
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Login</Modal.Title>
    //             </Modal.Header>
    //             <Form onSubmit={(event) => {
    //                 event.preventDefault();
    //                 doLogin();
    //             }}>
    //                 <Modal.Body>

    //                     {errorMessage !== '' &&
    //                         <Alert key={'danger'} variant={'danger'}>
    //                             {errorMessage}
    //                         </Alert>
    //                     }
    //                     <Form.Group className="mb-3" controlId="Login.Email">
    //                         <Form.Label>Email<sup>*</sup></Form.Label>
    //                         <Form.Control
    //                             required={true}
    //                             type="email"
    //                             placeholder="Email"
    //                             value={email}
    //                             onChange={(e) => setEmail(e.target.value)}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className="mb-3" controlId="Login.Password">
    //                         <Form.Label>Password<sup>*</sup></Form.Label>
    //                         <Form.Control
    //                             required={true}
    //                             type="password"
    //                             placeholder="Password"
    //                             value={password}
    //                             onChange={(e) => setPassword(e.target.value)}
    //                         />
    //                     </Form.Group>

    //                 </Modal.Body>
    //                 <Modal.Footer>
    //                     <Button variant="secondary" onClick={handleClose}>
    //                         Close
    //                     </Button>
    //                     <Button variant="primary" type={'submit'} onClick={(event) => {
    //                         event.preventDefault();
    //                         doLogin();
    //                     }}>
    //                         Login
    //                     </Button>
    //                 </Modal.Footer>
    //             </Form>
    //         </Modal>
    //     </>
    // );
};
export default Login;
